<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  export default {
    name: 'ScoresModule',
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
    },
  }
</script>
